import { render, staticRenderFns } from "./PrivacyDocumentView.vue?vue&type=template&id=600ec5d0"
import script from "./PrivacyDocumentView.vue?vue&type=script&lang=js"
export * from "./PrivacyDocumentView.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDocumentView.vue?vue&type=style&index=0&id=600ec5d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports